import PropTypes from "prop-types";
import React, { useState } from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap";

import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { changePasswordThunk } from "../../slices/auth/changepwd/thunk";

import logoLight from "../../assets/images/logo-light.png";
import { createSelector } from "reselect";

const ChangePassword = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Please Enter Password"),
      newPassword: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Please Enter New Password"),
    }),
    onSubmit: async (values) => {
      if (values.newPassword !== values.confirmPassword) {
        return;
      }

      const authUser = JSON.parse(sessionStorage.getItem("authUser"));
      if (!authUser?.data?.id) {
        navigate("/login");
        return;
      }
      const data = {
        newPassword: values?.newPassword,
        oldPassword: values?.oldPassword,
      };
      const id = authUser?.data?.id;

      await dispatch(changePasswordThunk(id, data, props.router.navigate));
      validation.resetForm();
    },
  });

  const selectLayoutState = (state) => state.ChangePassword;
  const selectLayoutProperties = createSelector(selectLayoutState, (state) => ({
    changeError: state.changeError,
    changeSuccessMsg: state.changeSuccessMsg,
  }));

  const { changeError, changeSuccessMsg } = useSelector(selectLayoutProperties);

  document.title = "Reset Password";

  return (
    <div className="auth-page-content d-flex align-items-center justify-content-center min-vh-100">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="mt-4">
              <CardBody className="p-4">
                <div className="text-center mt-2">
                  <h5 className="text-success">Reset Password</h5>
                  <lord-icon
                    src="https://cdn.lordicon.com/rhvddzym.json"
                    trigger="loop"
                    colors="primary:#0ab39c"
                    className="avatar-xl"
                    style={{ width: "120px", height: "120px" }}
                  ></lord-icon>
                </div>

                <Alert
                  className="border-0 alert-warning text-center mb-2 mx-2"
                  role="alert"
                >
                  Enter your old password and new password
                </Alert>

                <div className="p-2 ">
                  {changeError && (
                    <Alert color="danger" className="text-center mt-2">
                      {changeError}
                    </Alert>
                  )}
                  {changeSuccessMsg && (
                    <Alert color="success" className="text-center mt-2">
                      {changeSuccessMsg}
                    </Alert>
                  )}

                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    {/* <div className="mb-3">
                      <Label className="form-label">Old Password</Label>
                      <Input
                        name="oldPassword"
                        className="form-control"
                        placeholder="Enter old password"
                        type="password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.oldPassword || ""}
                        invalid={
                          validation.touched.oldPassword &&
                          validation.errors.oldPassword
                            ? true
                            : false
                        }
                      />
                      {validation.touched.oldPassword &&
                        validation.errors.oldPassword && (
                          <FormFeedback type="invalid">
                            {validation.errors.oldPassword}
                          </FormFeedback>
                        )}
                    </div> */}

                    <div className="mb-3">
                      <Label className="form-label">Old Password</Label>

                      <div className="position-relative">
                        <Input
                          name="oldPassword"
                          className="form-control pe-5"
                          placeholder="Enter old password"
                          type={showOldPassword ? "text" : "password"}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.oldPassword || ""}
                          invalid={
                            validation.touched.oldPassword &&
                            validation.errors.oldPassword
                              ? true
                              : false
                          }
                        />

                        <button
                          type="button"
                          className="btn btn-sm btn-light position-absolute end-0 top-50 translate-middle-y me-2"
                          onClick={() => setShowOldPassword((prev) => !prev)}
                          tabIndex={-1}
                        >
                          <i
                            className={`ri-eye${
                              showOldPassword ? "-off" : ""
                            }-line`}
                          />
                        </button>
                      </div>

                      {validation.touched.oldPassword &&
                        validation.errors.oldPassword && (
                          <FormFeedback type="invalid" className="d-block">
                            {validation.errors.oldPassword}
                          </FormFeedback>
                        )}
                    </div>

                    {/* <div className="mb-4">
                      <Label className="form-label">New Password</Label>
                      <Input
                        name="newPassword"
                        className="form-control"
                        placeholder="Enter new password"
                        type="password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.newPassword || ""}
                        invalid={
                          validation.touched.newPassword &&
                          validation.errors.newPassword
                            ? true
                            : false
                        }
                      />
                      {validation.touched.newPassword &&
                        validation.errors.newPassword && (
                          <FormFeedback type="invalid">
                            {validation.errors.newPassword}
                          </FormFeedback>
                        )}
                    </div> */}

                    <div className="mb-4">
                      <Label className="form-label">New Password</Label>

                      <div className="position-relative">
                        <Input
                          name="newPassword"
                          className="form-control pe-5"
                          placeholder="Enter new password"
                          type={showNewPassword ? "text" : "password"}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.newPassword || ""}
                          invalid={
                            validation.touched.newPassword &&
                            validation.errors.newPassword
                              ? true
                              : false
                          }
                        />

                        <button
                          type="button"
                          className="btn btn-sm btn-light position-absolute end-0 top-50 translate-middle-y me-2"
                          onClick={() => setShowNewPassword((prev) => !prev)}
                          tabIndex={-1}
                        >
                          <i
                            className={`ri-eye${
                              showNewPassword ? "-off" : ""
                            }-line`}
                          />
                        </button>
                      </div>

                      {validation.touched.newPassword &&
                        validation.errors.newPassword && (
                          <FormFeedback type="invalid" className="d-block">
                            {validation.errors.newPassword}
                          </FormFeedback>
                        )}
                    </div>

                    <div className="mb-4">
                      <Label className="form-label">Confirm Password</Label>

                      <div className="position-relative">
                        <Input
                          name="confirmPassword"
                          className="form-control pe-5"
                          placeholder="Confirm new password"
                          type={showConfirmPassword ? "text" : "password"}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.confirmPassword || ""}
                          invalid={
                            validation.touched.confirmPassword &&
                            (validation.errors.confirmPassword ||
                              validation.values.confirmPassword !==
                                validation.values.newPassword)
                              ? true
                              : false
                          }
                        />

                        <button
                          type="button"
                          className="btn btn-sm btn-light position-absolute end-0 top-50 translate-middle-y me-2"
                          onClick={() =>
                            setShowConfirmPassword((prev) => !prev)
                          }
                          tabIndex={-1}
                        >
                          <i
                            className={`ri-eye${
                              showConfirmPassword ? "-off" : ""
                            }-line`}
                          />
                        </button>
                      </div>

                      {validation.touched.confirmPassword &&
                        validation.values.confirmPassword !==
                          validation.values.newPassword && (
                          <FormFeedback type="invalid" className="d-block">
                            Password not matched
                          </FormFeedback>
                        )}
                    </div>

                    <div className="text-center mt-4">
                      <button className="btn btn-success w-100" type="submit">
                        Reset Password
                      </button>
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>
            {/* 
            <div className="mt-4 text-center">
              <p className="mb-0">
                Go back to{" "}
                <Link
                  to="/login"
                  className="fw-semibold text-primary text-decoration-underline"
                >
                  Login
                </Link>
              </p>
            </div> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

ChangePassword.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ChangePassword);
